export default function Google({ className = "" }) {
  return (
    <svg width="14" height="103" viewBox="0 0 14 103" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H14V88.1442L0 103V0Z" fill="#00C22B" />
    </svg>
  )
}
